import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";


const PhonecentersSysModelForm = ({ type, initialValues, onSubmit }: PhonecentersSysModelFormProps) => {
    const { t } = useTranslation();

    const validationSchema= Yup.object({
      description: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    })

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          if (type === "create") {
            onSubmit(values, formikHelpers);
          } else {
            onSubmit(
              values, formikHelpers
            );
          }
        }}
        validationSchema={validationSchema}
      >
        {({ errors, touched, isSubmitting, values, getFieldProps }) => (
          <Form>
            <Container fluid className="p-0">
              <Row>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Όνομα Μοντέλου")}*`}
                  </label>
                  <Field
                    name="description"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="description"
                   
                  />
                  <div className="text-danger">
                    {errors.description && touched.description && (
                      <div>{errors.description}</div>
                    )}
                  </div>
                </Col>
            
              </Row>
            </Container>

            <div className="mb-3">
              <Button
                type="submit"
                size="sm"
                styletype="primary"
                disabled={isSubmitting}
              >
                {type == "create" ? t("Δημιουργία") : t("Αποθήκευση")}
              </Button>
            </div>
          </Form>
      )}
      </Formik>
  )
}

export default PhonecentersSysModelForm;

type CreateOrEdit =
  | {
      type: "create";
      initialValues: IPostNewPhonecentersSysModel;
      onSubmit: (
        values: IPostNewPhonecentersSysModel,
        formikHelpers: FormikHelpers<IPostNewPhonecentersSysModel>
      ) => void;
    }
  | {
      type: "edit";
      initialValues: IPostEditPhonecentersSysModel;
      onSubmit: (
        values: IPostEditPhonecentersSysModel,
        formikHelpers: FormikHelpers<IPostEditPhonecentersSysModel>
      ) => void;
    };

type PhonecentersSysModelFormProps = CreateOrEdit;